import React from 'react';
import { AllowanceTableRow, DeductionTableRow } from './common';

interface AllowancesDeductionsTableProps {
  copiedInvoiceData: any;
  deductionsByFreelancer: { [key: string]: any[] };
  removedCopiedWorkingHours: Set<number>;
  freelancerId: string;
  t: (key: string) => string;
  onEditAllowance: (deductionData: any) => void;
  onRemoveAllowance: (originalIndex: number) => void;
  onEditDeduction: (index: number) => void;
  onRemoveDeduction: (index: number) => void;
}

export const AllowancesDeductionsTable: React.FC<AllowancesDeductionsTableProps> = ({
  copiedInvoiceData,
  deductionsByFreelancer,
  removedCopiedWorkingHours,
  freelancerId,
  t,
  onEditAllowance,
  onRemoveAllowance,
  onEditDeduction,
  onRemoveDeduction
}) => {
  // Check if there's any data to display
  const workingHoursData = copiedInvoiceData?.workingHours?.filter((wh: any) => {
    const isServiceArticle = ['92', '94', '95', '96', '97'].includes(wh.articleNumber);
    const isTargetFreelancer = freelancerId === 'default' 
      ? (!copiedInvoiceData.multipleFreelancer || !wh.userId)
      : (wh.userId === parseInt(freelancerId));
    return !isServiceArticle && isTargetFreelancer;
  }) || [];
  
  const deductionsData = deductionsByFreelancer[freelancerId] || [];
  const hasData = workingHoursData.length > 0 || deductionsData.length > 0;
  
  if (!hasData) return null;
  
  return (
    <div className="allowances-table">
      <div className="table-header">
        <div className="col-drag"></div>
        <div className="col-dates-allowance">{t('DATE_S')}</div>
        <div className="col-allowance-type">{t('ALLOWANCE_TYPE')}</div>
        <div className="col-attachment">{t('ATTACHMENT')}</div>
        <div className="col-price-allowance">{t('PRICE')}</div>
        <div className="col-actions-allowance"></div>
      </div>

      <div className="table-body">
        {/* Show working hours with non-service article numbers */}
        {copiedInvoiceData?.workingHours?.filter((wh: any, whOriginalIndex: number) => {
          const isServiceArticle = ['92', '94', '95', '96', '97'].includes(wh.articleNumber);
          const isTargetFreelancer = freelancerId === 'default' 
            ? (!copiedInvoiceData.multipleFreelancer || !wh.userId)
            : (wh.userId === parseInt(freelancerId));
          return !isServiceArticle && isTargetFreelancer && !removedCopiedWorkingHours.has(whOriginalIndex);
        }).map((workingHour: any) => {
          const originalIndex = copiedInvoiceData?.workingHours?.findIndex((wh: any) => wh === workingHour) || 0;

          return (
            <AllowanceTableRow
              key={`wh-${originalIndex}`}
              workingHour={workingHour}
              originalIndex={originalIndex}
              t={t}
              onEdit={onEditAllowance}
              onRemove={() => onRemoveAllowance(originalIndex)}
            />
          );
        })}
        
        {/* Show deductions */}
        {deductionsData.map((deduction: any, index: number) => (
          <DeductionTableRow
            key={index}
            deduction={deduction}
            index={index}
            t={t}
            onEdit={() => onEditDeduction(index)}
            onRemove={() => onRemoveDeduction(index)}
          />
        ))}
      </div>
    </div>
  );
};
